// Digest: 4b9e27bc5b0fbca9e9b88d5cb6a7a1f974c487e4
/* eslint-disable */
/// <reference types="vite/client.d.ts" />/* eslint-disable */
/**
 * This file was automatically generated by json-schema-to-typescript.
 * DO NOT MODIFY IT BY HAND. Instead, modify the source JSONSchema file,
 * and run json-schema-to-typescript to regenerate this file.
 */

export type ContainerSizeSubBlockOrNull = null | ContainerSizeSubBlock;
export type AlignedRichTextSubBlockOrNull = null | AlignedRichTextSubBlock;
export type RichTextBlockOrNull = null | RichTextBlock;
export type RichTextBlock = string;
export type _SlideListOrNull = null | _SlideList;
export type ImageChooserBlockOrNull = null | ImageChooserBlock;
export type _SlideList = _Slide[];
export type CharBlockOrNull = null | CharBlock;
export type CharBlock = string;
export type EmbedBlockOrNull = null | EmbedBlock;
export type EmbedBlock = string;
export type MediaChooserBlock = (
  | {
      type: "image";
      value: ImageChooserBlock;
      id: string;
    }
  | {
      type: "video";
      value: VideoChooserBlock;
      id: string;
    }
  | {
      type: "embed";
      value: MediaEmbedBlock;
      id: string;
    }
)[];
export type SimpleLinkBlockOrNull = null | SimpleLinkBlock;
export type URLBlockOrNull = null | URLBlock;
export type URLBlock = string;
export type TableBlockOrNull = null | TableBlock;
export type TableBlock = string;
export type LabUIToolbox = (
  | {
      type: "alignedrichtextblock";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "gallerysubblock";
      value: GallerySubBlock;
      id: string;
    }
  | {
      type: "linksubblock";
      value: LinkSubBlock;
      id: string;
    }
  | {
      type: "mediachooserblock";
      value: MediaChooserBlock;
      id: string;
    }
  | {
      type: "scrollnavmenublock";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "scrollnavmenuitemblock";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "socialmediaicon";
      value: SocialMediaIcon;
      id: string;
    }
  | {
      type: "spacerblock";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "tableincontainerblock";
      value: TableInContainerBlock;
      id: string;
    }
  | {
      type: "onetrustprivacynoticeblock";
      value: OneTrustPrivacyNoticeBlock;
      id: string;
    }
  | {
      type: "videochooserblock";
      value: VideoChooserBlock;
      id: string;
    }
)[];
export type MediaChooserBlockOrNull = null | MediaChooserBlock;
export type ImageThreeUpBlockListOrNull = null | ImageThreeUpBlockList;
export type BasicRichTextWithCtaOrNull = null | BasicRichTextWithCta;
export type BasicRichTextWithCta = string;
export type ImageThreeUpBlockList = ImageThreeUpBlock[];
export type ThreeUpBlockListOrNull = null | ThreeUpBlockList;
export type ThreeUpBlockList = ThreeUpBlock[];
export type ImageWithCaptionBlockListOrNull = null | ImageWithCaptionBlockList;
export type LockedDownRichTextOrNull = null | LockedDownRichText;
export type LockedDownRichText = string;
export type ImageWithCaptionBlockList = ImageWithCaptionBlock[];
export type ValuePropBlockListOrNull = null | ValuePropBlockList;
export type ValuePropBlockList = ValuePropBlock[];
export type StaticBlockOrNull = null | StaticBlock;
export type Blocks = (
  | {
      type: "big_hero";
      value: BigHeroBlock;
      id: string;
    }
  | {
      type: "faq";
      value: FaqBlock;
      id: string;
    }
  | {
      type: "full_width_media";
      value: FullWidthMediaBlock;
      id: string;
    }
  | {
      type: "image_3up";
      value: Image3UpBlock;
      id: string;
    }
  | {
      type: "image_3up_hover";
      value: Image3UpHoverBlock;
      id: string;
    }
  | {
      type: "image_text_carousel";
      value: ImageTextCarouselBlock;
      id: string;
    }
  | {
      type: "media_pull_quote_carousel";
      value: MediaPullQuoteCarouselBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "scrolling_image_gallery";
      value: ScrollingImageGalleryBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "specs";
      value: SpecsBlock;
      id: string;
    }
  | {
      type: "value_props";
      value: ValuePropsBlock;
      id: string;
    }
  | {
      type: "form";
      value: FormBlock;
      id: string;
    }
)[];
export type Toolbox = (
  | {
      type: "big_hero";
      value: BigHeroBlock;
      id: string;
    }
  | {
      type: "faq";
      value: FaqBlock;
      id: string;
    }
  | {
      type: "full_width_media";
      value: FullWidthMediaBlock;
      id: string;
    }
  | {
      type: "image_3up";
      value: Image3UpBlock;
      id: string;
    }
  | {
      type: "image_3up_hover";
      value: Image3UpHoverBlock;
      id: string;
    }
  | {
      type: "image_text_carousel";
      value: ImageTextCarouselBlock;
      id: string;
    }
  | {
      type: "media_pull_quote_carousel";
      value: MediaPullQuoteCarouselBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "scrolling_image_gallery";
      value: ScrollingImageGalleryBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "specs";
      value: SpecsBlock;
      id: string;
    }
  | {
      type: "value_props";
      value: ValuePropsBlock;
      id: string;
    }
)[];
export type SlidingCardBlockListOrNull = null | SlidingCardBlockList;
export type ColumnBlockListOrNull = null | ColumnBlockList;
export type ColumnBlockList = ColumnBlock[];
export type SlidingCardBlockList = SlidingCardBlock[];
export type SplitPanelCardBlockListOrNull = null | SplitPanelCardBlockList;
export type SplitPanelCardBlockList = SplitPanelCardBlock[];
export type ProductDetailPageBlocks = (
  | {
      type: "big_hero";
      value: BigHeroBlock;
      id: string;
    }
  | {
      type: "faq";
      value: FaqBlock;
      id: string;
    }
  | {
      type: "full_width_media";
      value: FullWidthMediaBlock;
      id: string;
    }
  | {
      type: "image_3up";
      value: Image3UpBlock;
      id: string;
    }
  | {
      type: "image_3up_hover";
      value: Image3UpHoverBlock;
      id: string;
    }
  | {
      type: "image_text_carousel";
      value: ImageTextCarouselBlock;
      id: string;
    }
  | {
      type: "media_pull_quote_carousel";
      value: MediaPullQuoteCarouselBlock;
      id: string;
    }
  | {
      type: "rich_text";
      value: AlignedRichTextBlock;
      id: string;
    }
  | {
      type: "scrolling_image_gallery";
      value: ScrollingImageGalleryBlock;
      id: string;
    }
  | {
      type: "spacer";
      value: SpacerBlock;
      id: string;
    }
  | {
      type: "specs";
      value: SpecsBlock;
      id: string;
    }
  | {
      type: "value_props";
      value: ValuePropsBlock;
      id: string;
    }
  | {
      type: "nav_menu";
      value: ScrollNavMenuBlock;
      id: string;
    }
  | {
      type: "nav_menu_item";
      value: ScrollNavMenuItemBlock;
      id: string;
    }
  | {
      type: "sliding_cards";
      value: SlidingCardsBlock;
      id: string;
    }
  | {
      type: "split_panel_cards";
      value: SplitPanelCardsBlock;
      id: string;
    }
)[];
export type MetaTagsBlock = (
  | {
      type: "domain_verification";
      value: DomainVerificationBlock;
      id: string;
    }
  | {
      type: "ga4";
      value: GoogleAnalyticsFour;
      id: string;
    }
  | {
      type: "gtm";
      value: GoogleTagManagerBlock;
      id: string;
    }
  | {
      type: "onetrust_cookie_settings";
      value: OneTrustCookieSettingsBlock;
      id: string;
    }
)[];
export type AnnouncementBarBlock = {
  type: "announcements";
  value: SimpleLinkBlock;
  id: string;
}[];
export type SimpleLinkBlockListOrNull = null | SimpleLinkBlockList;
export type SimpleLinkBlockList = SimpleLinkBlock[];
export type Level1MenuBlockList = Level1MenuBlock[];
export type HeaderNavigationMenuBlock = {
  type: "level_1_items";
  value: Level1MenuBlockList;
  id: string;
}[];
export type FooterLinksStreamBlock = (
  | {
      type: "text";
      value: LockedDownRichText;
      id: string;
    }
  | {
      type: "link";
      value: SimpleLinkBlock;
      id: string;
    }
)[];
export type FooterNavigationMenuBlock = (
  | {
      type: "cta";
      value: SimpleLinkWithSubtextBlock;
      id: string;
    }
  | {
      type: "links";
      value: FooterLinksStreamBlock;
      id: string;
    }
)[];

export interface _Types {
  BasePageTemplateProps: ThelabuiModelsPagesBasePageBasePageTemplate;
  BaseFormPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate;
  BaseFormPageLandingPageTemplateProps: ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate;
  ExamplePageTemplateProps: ThelabuiModelsPagesExamplePageExamplePageTemplate;
  LabUIToolboxSnippetPreviewProps: ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview;
  FormPageTemplateProps: ServerCmsModelsPagesFormFormPageTemplate;
  FormLandingPageTemplateProps: ServerCmsModelsPagesFormFormLandingPageTemplate;
  HomePageTemplateProps: ServerCmsModelsPagesHomeHomePageTemplate;
  ProductDetailPageTemplateProps: ServerCmsModelsPagesPdpProductDetailPageTemplate;
  UtilityPageTemplateProps: ServerCmsModelsPagesUtilityUtilityPageTemplate;
  globals: {
    Widget: generated.Types["Widget"];
    models: {};
  };
  Context: ReactivatedSerializationContextProcessorsBaseContext &
    ReactivatedSerializationContextProcessorsMessagesProcessor &
    ReactivatedSerializationContextProcessorsCSRFProcessor &
    ReactivatedSerializationContextProcessorsRequestProcessor &
    ReactivatedSerializationContextProcessorsStaticProcessor &
    ThelabuiContextProcessorsTranslationProcessor &
    ThelabuiContextProcessorsMetaTagsProcessor &
    ServerCmsContextProcessorsCoreAssetProcessor &
    ServerCmsContextProcessorsNavigationProcessor &
    ServerCmsContextProcessorsSettingsProcessor;
  RPCPermission: null;
}
export interface ThelabuiModelsPagesBasePageBasePageTemplate {
  is_preview: boolean;
  page: BasePageEb66F00405;
}
export interface BasePageEb66F00405 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface ThelabuiTypesLanguage {
  code: string;
  vernacular_name: string;
  translated_name: string;
  dir: "ltr" | "rtl" | "auto";
}
export interface ThelabuiTypesAlternatePage {
  title: string;
  url: string;
  language: ThelabuiTypesLanguage;
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
  form: DjangoFormsForms;
}
export interface BaseFormPageFe4F84D43A {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
}
export interface DjangoFormsForms {
  name: "django.forms.forms.Form";
  errors: {} | null;
  fields: {};
  prefix: string;
  iterator: [];
  hidden_fields?: [];
}
export interface ThelabuiModelsPagesBaseFormPageBaseFormPageLandingPageTemplate {
  is_preview: boolean;
  page: BaseFormPageFe4F84D43A;
}
export interface ThelabuiModelsPagesExamplePageExamplePageTemplate {
  is_preview: boolean;
  page: ExamplePage_8C9639Cb8F;
}
export interface ExamplePage_8C9639Cb8F {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  image: {
    block: ThelabuiSerializationImagesImageBlockValue;
  } | null;
  image_tile: {
    renditions_webp: WagtailImageRendition[];
  } | null;
  richtext: RichTextField;
  body: ThelabuiExamplePage;
  snippets: {
    body: ThelabuiLabUIToolboxSnippet;
  }[];
  attachment: {
    title: string;
    created_at: string;
    file_size: number | null;
    file_hash: string;
    filename: string;
    file_extension: string;
    url: string;
    content_type: string;
    content_disposition: string;
    file: FileField;
    tags: {
      name: string;
    }[];
  } | null;
}
export interface ThelabuiSerializationImagesImageBlockValue {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    [k: string]: ThelabuiSerializationImagesImageRenditionBlockValue;
  };
}
export interface ThelabuiSerializationImagesImageRenditionBlockValue {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface WagtailImageRendition {
  spec: string;
  width: number;
  height: number;
  url: string;
  size: number;
  mimetype: string;
}
export interface RichTextField {
  _type: "RichTextField";
  html: string;
}
export interface ThelabuiExamplePage {
  _type: "StreamField";
  _variant: "thelabui.ExamplePage.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface AlignedRichTextBlock {
  container?: ContainerSizeSubBlockOrNull;
  content?: AlignedRichTextSubBlockOrNull;
  theme: null | ("match" | "contrast" | "gradient");
  overlay: null | ("overlayOff" | "overlayBottom" | "overlayTop" | "overlayTopBottom" | "overlayCover");
  text_size: null | ("textSizeRegular" | "textSizeLarge");
  space_before:
    | null
    | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge" | "nano" | "micro" | "xxxlarge");
  space_after:
    | null
    | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge" | "nano" | "micro" | "xxxlarge");
}
export interface ContainerSizeSubBlock {
  width?: null | ("" | "full" | "twoThirds" | "half");
}
export interface AlignedRichTextSubBlock {
  content?: RichTextBlockOrNull;
  alignment?: null | ("" | "textAlignCenter" | "textAlignRight");
}
export interface GallerySubBlock {
  slides?: _SlideListOrNull;
}
export interface _Slide {
  image: ImageChooserBlockOrNull;
  caption?: AlignedRichTextSubBlockOrNull;
}
export interface ImageChooserBlock {
  title: string;
  width: number;
  height: number;
  brightness: number;
  url: string;
  renditions: {
    /**
     * This interface was referenced by `undefined`'s JSON-Schema definition
     * via the `patternProperty` "^.*$".
     */
    [k: string]: {
      spec: string;
      width: number;
      height: number;
      url: string;
      size: number;
      mimetype: string;
    };
  };
}
export interface LinkSubBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  link_style?: null | ("" | "secondary" | "text-link");
  url: null | string;
}
export interface VideoChooserBlock {
  poster: null | string;
  sources: {
    url: string;
    mimetype: string;
  }[];
  title: string;
  tracks: {
    kind: string;
    kind_name: string;
    src: string;
    label: string;
    srclang: string;
    srclang_name: null | string;
    sort_order: number;
  }[];
  width: null | number;
  height: null | number;
  aspectRatio: null | number;
}
export interface MediaEmbedBlock {
  title: CharBlockOrNull;
  thumbnail: ImageChooserBlockOrNull;
  embed: EmbedBlockOrNull;
}
export interface ScrollNavMenuBlock {
  right_cta?: SimpleLinkBlockOrNull;
}
export interface SimpleLinkBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  url: null | string;
}
export interface ScrollNavMenuItemBlock {
  name: CharBlockOrNull;
}
export interface SocialMediaIcon {
  icon: null | ("facebook" | "instagram" | "linkedin" | "pinterest" | "tiktok" | "twitter" | "youtube");
  link: URLBlockOrNull;
}
export interface SpacerBlock {
  anchor?: CharBlockOrNull;
  height: null | ("no-height" | "small" | "medium" | "large" | "xlarge" | "xxlarge" | "nano" | "micro" | "xxxlarge");
  theme: null | ("match" | "contrast");
}
export interface TableInContainerBlock {
  container?: ContainerSizeSubBlockOrNull;
  table: TableBlockOrNull;
}
export interface OneTrustPrivacyNoticeBlock {
  script_url: URLBlockOrNull;
  callback_url: URLBlockOrNull;
  notice_url: URLBlockOrNull;
}
export interface ThelabuiLabUIToolboxSnippet {
  _type: "StreamField";
  _variant: "thelabui.LabUIToolboxSnippet.body";
  value: LabUIToolbox;
  [k: string]: unknown;
}
export interface FileField {
  url: string;
}
export interface ThelabuiModelsSnippetsToolboxSnippetLabUIToolboxSnippetPreview {
  object: LabUIToolboxSnippetFdc2906E1B;
}
export interface LabUIToolboxSnippetFdc2906E1B {
  id: number;
  name: string;
  body: ThelabuiLabUIToolboxSnippet;
}
export interface ServerCmsModelsPagesFormFormPageTemplate {
  is_preview: boolean;
  page: FormPage_22630022Fa;
  form: WagtailForm;
}
export interface FormPage_22630022Fa {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  body: CmsFormPage;
}
export interface CmsFormPage {
  _type: "StreamField";
  _variant: "cms.FormPage.body";
  value: Blocks;
  [k: string]: unknown;
}
export interface BigHeroBlock {
  content: RichTextBlockOrNull;
  media?: MediaChooserBlockOrNull;
  content_alignment: null | ("top-left" | "middle-left" | "bottom-left" | "center-center");
  text_size: null | ("textSizeRegular" | "textSizeLarge");
  text_color: null | ("light" | "dark");
  overlay: null | ("overlayOff" | "overlayBottom" | "overlayTop" | "overlayTopBottom" | "overlayCover");
  animation: null | ("animateNone" | "animateCurtains");
}
export interface FaqBlock {
  header: CharBlockOrNull;
  background: null | ("transparent" | "gradient");
  entries:
    | null
    | {
        type: "faq_entry";
        value: FaqEntry;
        id: string;
      }[];
}
export interface FaqEntry {
  question: CharBlockOrNull;
  answer: RichTextBlockOrNull;
}
export interface FullWidthMediaBlock {
  media: MediaChooserBlockOrNull;
}
export interface Image3UpBlock {
  header_content?: RichTextBlockOrNull;
  items?: ImageThreeUpBlockListOrNull;
  theme: null | ("match" | "contrast");
}
export interface ImageThreeUpBlock {
  media: MediaChooserBlockOrNull;
  content: BasicRichTextWithCtaOrNull;
}
export interface Image3UpHoverBlock {
  header_content?: RichTextBlockOrNull;
  cta?: SimpleLinkBlockOrNull;
  items?: ThreeUpBlockListOrNull;
  theme: null | ("match" | "contrast");
}
export interface ThreeUpBlock {
  title: CharBlockOrNull;
  subtitle: CharBlockOrNull;
  media: MediaChooserBlockOrNull;
}
export interface ImageTextCarouselBlock {
  block_name: CharBlockOrNull;
  content: RichTextBlockOrNull;
  slides:
    | null
    | {
        type: "slide";
        value: ImageTextCarouselSlide;
        id: string;
      }[];
  theme: null | ("match" | "contrast");
}
export interface ImageTextCarouselSlide {
  media?: MediaChooserBlockOrNull;
  content?: RichTextBlockOrNull;
  cta?: SimpleLinkBlockOrNull;
}
export interface MediaPullQuoteCarouselBlock {
  block_name: CharBlockOrNull;
  content: RichTextBlockOrNull;
  media: MediaChooserBlockOrNull;
  slides:
    | null
    | {
        type: "pull_quote_slide";
        value: MediaPullQuoteSlide;
        id: string;
      }[];
  theme: null | ("match" | "contrast");
}
export interface MediaPullQuoteSlide {
  quote: CharBlockOrNull;
  citation_1: CharBlockOrNull;
  citation_2?: CharBlockOrNull;
}
export interface ScrollingImageGalleryBlock {
  header_content?: RichTextBlockOrNull;
  images?: ImageWithCaptionBlockListOrNull;
  theme: null | ("match" | "contrast");
}
export interface ImageWithCaptionBlock {
  media: MediaChooserBlockOrNull;
  content: LockedDownRichTextOrNull;
}
export interface SpecsBlock {
  columns:
    | null
    | {
        type: "column";
        value: SpecsColumn;
        id: string;
      }[];
}
export interface SpecsColumn {
  header: CharBlockOrNull;
  cells:
    | null
    | {
        type: "cell";
        value: SpecsCell;
        id: string;
      }[];
}
export interface SpecsCell {
  eyebrow: CharBlockOrNull;
  text: CharBlockOrNull;
}
export interface ValuePropsBlock {
  header_subtitle?: RichTextBlockOrNull;
  value_props?: ValuePropBlockListOrNull;
  cta?: SimpleLinkBlockOrNull;
  theme: null | ("match" | "contrast");
}
export interface ValuePropBlock {
  title: CharBlockOrNull;
  subtitle: CharBlockOrNull;
}
export interface FormBlock {
  help_text?: StaticBlockOrNull;
  header: RichTextBlockOrNull;
  results: RichTextBlockOrNull;
}
export interface StaticBlock {}
export interface WagtailForm {
  name: "django.forms.widgets.WagtailForm";
  errors: {} | null;
  fields: {
    [k: string]: {
      name: string;
      label: string;
      help_text?: string | null;
      widget: generated.Types["Widget"];
    };
  };
  prefix: string;
  iterator: string[];
  hidden_fields?: string[];
}
export interface ServerCmsModelsPagesFormFormLandingPageTemplate {
  is_preview: boolean;
  page: FormPage_22630022Fa;
}
export interface ServerCmsModelsPagesHomeHomePageTemplate {
  is_preview: boolean;
  page: HomePage_19C2C37Ca3;
}
export interface HomePage_19C2C37Ca3 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  color_theme: string;
  body: CmsHomePage;
}
export interface CmsHomePage {
  _type: "StreamField";
  _variant: "cms.HomePage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ServerCmsModelsPagesPdpProductDetailPageTemplate {
  is_preview: boolean;
  page: ProductDetailPageCc1044Bf3A;
}
export interface ProductDetailPageCc1044Bf3A {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  color_theme: string;
  body: CmsProductDetailPage;
}
export interface CmsProductDetailPage {
  _type: "StreamField";
  _variant: "cms.ProductDetailPage.body";
  value: ProductDetailPageBlocks;
  [k: string]: unknown;
}
export interface SlidingCardsBlock {
  cards?: SlidingCardBlockListOrNull;
  theme: null | ("match" | "contrast");
}
export interface SlidingCardBlock {
  media: MediaChooserBlockOrNull;
  title: CharBlockOrNull;
  columns?: ColumnBlockListOrNull;
}
export interface ColumnBlock {
  title?: CharBlockOrNull;
  subtitle?: CharBlockOrNull;
}
export interface SplitPanelCardsBlock {
  cards?: SplitPanelCardBlockListOrNull;
  theme: null | ("match" | "contrast");
}
export interface SplitPanelCardBlock {
  feature_media: MediaChooserBlockOrNull;
  detail_media: MediaChooserBlockOrNull;
  title: CharBlockOrNull;
  subtitle: CharBlockOrNull;
}
export interface ServerCmsModelsPagesUtilityUtilityPageTemplate {
  is_preview: boolean;
  page: UtilityPageAe0Dc4F817;
}
export interface UtilityPageAe0Dc4F817 {
  id: number;
  title: string;
  seo_title: string;
  search_description: string;
  first_published_at: string | null;
  language: ThelabuiTypesLanguage | null;
  alternate_pages: ThelabuiTypesAlternatePage[];
  color_theme: string;
  body: CmsUtilityPage;
}
export interface CmsUtilityPage {
  _type: "StreamField";
  _variant: "cms.UtilityPage.body";
  value: Toolbox;
  [k: string]: unknown;
}
export interface ReactivatedSerializationContextProcessorsBaseContext {
  template_name: string;
}
export interface ReactivatedSerializationContextProcessorsMessagesProcessor {
  messages: ReactivatedSerializationContextProcessorsMessage[];
}
export interface ReactivatedSerializationContextProcessorsMessage {
  level_tag: "info" | "success" | "error" | "warning" | "debug";
  message: string;
  level: number;
  from_server: boolean;
}
export interface ReactivatedSerializationContextProcessorsCSRFProcessor {
  csrf_token: string;
}
export interface ReactivatedSerializationContextProcessorsRequestProcessor {
  request: ReactivatedSerializationContextProcessorsRequest;
}
export interface ReactivatedSerializationContextProcessorsRequest {
  path: string;
  url: string;
  csp_nonce: string | null;
}
export interface ReactivatedSerializationContextProcessorsStaticProcessor {
  STATIC_URL: string;
}
export interface ThelabuiContextProcessorsTranslationProcessor {
  i18n: ThelabuiContextProcessorsTranslationCatalog;
}
export interface ThelabuiContextProcessorsTranslationCatalog {
  language: ThelabuiTypesLanguage;
  catalog: ThelabuiContextProcessorsCatalogEntry[];
  formats: ThelabuiContextProcessorsFormatEntry[];
}
export interface ThelabuiContextProcessorsCatalogEntry {
  key: string;
  value: string;
}
export interface ThelabuiContextProcessorsFormatEntry {
  key: string;
  value: string | number | string[];
}
export interface ThelabuiContextProcessorsMetaTagsProcessor {
  meta_tags: MetaTagSettings_3D1Fcbef23;
}
export interface MetaTagSettings_3D1Fcbef23 {
  meta_tags: ThelabuiMetaTagSettings;
}
export interface ThelabuiMetaTagSettings {
  _type: "StreamField";
  _variant: "thelabui.MetaTagSettings.meta_tags";
  value: MetaTagsBlock;
  [k: string]: unknown;
}
export interface DomainVerificationBlock {
  type: null | ("" | "google-site-verification" | "p:domain_verify" | "facebook-domain-verification");
  value: CharBlockOrNull;
}
export interface GoogleAnalyticsFour {
  container_id: CharBlockOrNull;
}
export interface GoogleTagManagerBlock {
  container_id: CharBlockOrNull;
}
export interface OneTrustCookieSettingsBlock {
  domain_script_uuid: CharBlockOrNull;
}
export interface ServerCmsContextProcessorsCoreAssetProcessor {
  core_assets: ServerCmsContextProcessorsCoreAssets;
}
export interface ServerCmsContextProcessorsCoreAssets {
  apple_touch_icon: string;
  favicon_png96: string;
  favicon_ico: string;
  favicon_svg: string;
}
export interface ServerCmsContextProcessorsNavigationProcessor {
  header_nav: HeaderNavigationSettings_670B61Bc60 | null;
  footer_nav: FooterNavigationSettingsFeb61E8D17 | null;
}
export interface HeaderNavigationSettings_670B61Bc60 {
  announcement_bar: CmsHeaderNavigationSettings;
  menu: CmsHeaderNavigationSettings1;
}
export interface CmsHeaderNavigationSettings {
  _type: "StreamField";
  _variant: "cms.HeaderNavigationSettings.announcement_bar";
  value: AnnouncementBarBlock;
  [k: string]: unknown;
}
export interface CmsHeaderNavigationSettings1 {
  _type: "StreamField";
  _variant: "cms.HeaderNavigationSettings.menu";
  value: HeaderNavigationMenuBlock;
  [k: string]: unknown;
}
export interface Level1MenuBlock {
  link?: SimpleLinkBlockOrNull;
  level_2_items?: SimpleLinkBlockListOrNull;
}
export interface FooterNavigationSettingsFeb61E8D17 {
  nav: CmsFooterNavigationSettings;
}
export interface CmsFooterNavigationSettings {
  _type: "StreamField";
  _variant: "cms.FooterNavigationSettings.nav";
  value: FooterNavigationMenuBlock;
  [k: string]: unknown;
}
export interface SimpleLinkWithSubtextBlock {
  display_name?: CharBlockOrNull;
  link_type?: null | ("page" | "external" | "email" | "document");
  anchor?: CharBlockOrNull;
  subtitle?: CharBlockOrNull;
  url: null | string;
}
export interface ServerCmsContextProcessorsSettingsProcessor {
  SENTRY_DSN: string | null;
  CI_COMMIT_REF_SLUG: string;
  CI_COMMIT_SHA: string;
}
export class RPC {
    constructor(public requester: rpcUtils.Requester) {
    }
}
export type UUID = `${string}-${string}-${string}-${string}-${string}`;

import type {Renderer as GenericRenderer} from "reactivated/dist/render.mjs";
export type Renderer = GenericRenderer<_Types["Context"]>;

export const rpc = new RPC(typeof window != "undefined" ? rpcUtils.defaultRequester : null as any);
import React from "react"
import * as generated from "reactivated/dist/generated";
import * as rpcUtils from "reactivated/dist/rpc";
import {constants} from "./constants";
export {constants};

export function classNames(...classes: (string | undefined | null | false)[]) {
    return classes.filter(Boolean).join(" ");
}

// Note: this needs strict function types to behave correctly with excess properties etc.
export type Checker<P, U extends (React.FunctionComponent<P> | React.ComponentClass<P>)> = {};

export type Result<TSuccess, TInvalid> = rpcUtils.Result<TSuccess, TInvalid, _Types["RPCPermission"]>;

export {Context} from "./context";
import {Context} from "./context";

import * as forms from "reactivated/dist/forms";
export type {FormHandler} from "reactivated/dist/forms";
export {reverse} from "./urls";

export const Provider = (props: {value: _Types["Context"]; children: React.ReactNode}) => {
    const [value, setValue] = React.useState(props.value);

    return (
        <Context.Provider value={{...value, setValue}}>
            {props.children}
        </Context.Provider>
    );
};

export const getServerData = () => {
    const props: Record<string, unknown> = (window as any).__PRELOADED_PROPS__;
    const context: _Types["Context"] = (window as any).__PRELOADED_CONTEXT__;

    return {props, context};
};

export type models = _Types["globals"]["models"];

export type {FieldHandler} from "./forms";
export {Form, FormSet, Widget, useForm, useFormSet, ManagementForm} from "reactivated/dist/forms";


import {Template as BasePageTemplateImplementation} from "@client/templates/BasePageTemplate"
export type BasePageTemplateCheck = Checker<_Types["BasePageTemplateProps"], typeof BasePageTemplateImplementation>;

export namespace templates {
    export type BasePageTemplate = _Types["BasePageTemplateProps"];
}


        



import {Template as BaseFormPageTemplateImplementation} from "@client/templates/BaseFormPageTemplate"
export type BaseFormPageTemplateCheck = Checker<_Types["BaseFormPageTemplateProps"], typeof BaseFormPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageTemplate = _Types["BaseFormPageTemplateProps"];
}


        



import {Template as BaseFormPageLandingPageTemplateImplementation} from "@client/templates/BaseFormPageLandingPageTemplate"
export type BaseFormPageLandingPageTemplateCheck = Checker<_Types["BaseFormPageLandingPageTemplateProps"], typeof BaseFormPageLandingPageTemplateImplementation>;

export namespace templates {
    export type BaseFormPageLandingPageTemplate = _Types["BaseFormPageLandingPageTemplateProps"];
}


        



import {Template as ExamplePageTemplateImplementation} from "@client/templates/ExamplePageTemplate"
export type ExamplePageTemplateCheck = Checker<_Types["ExamplePageTemplateProps"], typeof ExamplePageTemplateImplementation>;

export namespace templates {
    export type ExamplePageTemplate = _Types["ExamplePageTemplateProps"];
}


        



import {Template as LabUIToolboxSnippetPreviewImplementation} from "@client/templates/LabUIToolboxSnippetPreview"
export type LabUIToolboxSnippetPreviewCheck = Checker<_Types["LabUIToolboxSnippetPreviewProps"], typeof LabUIToolboxSnippetPreviewImplementation>;

export namespace templates {
    export type LabUIToolboxSnippetPreview = _Types["LabUIToolboxSnippetPreviewProps"];
}


        



import {Template as FormPageTemplateImplementation} from "@client/templates/FormPageTemplate"
export type FormPageTemplateCheck = Checker<_Types["FormPageTemplateProps"], typeof FormPageTemplateImplementation>;

export namespace templates {
    export type FormPageTemplate = _Types["FormPageTemplateProps"];
}


        



import {Template as FormLandingPageTemplateImplementation} from "@client/templates/FormLandingPageTemplate"
export type FormLandingPageTemplateCheck = Checker<_Types["FormLandingPageTemplateProps"], typeof FormLandingPageTemplateImplementation>;

export namespace templates {
    export type FormLandingPageTemplate = _Types["FormLandingPageTemplateProps"];
}


        



import {Template as HomePageTemplateImplementation} from "@client/templates/HomePageTemplate"
export type HomePageTemplateCheck = Checker<_Types["HomePageTemplateProps"], typeof HomePageTemplateImplementation>;

export namespace templates {
    export type HomePageTemplate = _Types["HomePageTemplateProps"];
}


        



import {Template as ProductDetailPageTemplateImplementation} from "@client/templates/ProductDetailPageTemplate"
export type ProductDetailPageTemplateCheck = Checker<_Types["ProductDetailPageTemplateProps"], typeof ProductDetailPageTemplateImplementation>;

export namespace templates {
    export type ProductDetailPageTemplate = _Types["ProductDetailPageTemplateProps"];
}


        



import {Template as UtilityPageTemplateImplementation} from "@client/templates/UtilityPageTemplate"
export type UtilityPageTemplateCheck = Checker<_Types["UtilityPageTemplateProps"], typeof UtilityPageTemplateImplementation>;

export namespace templates {
    export type UtilityPageTemplate = _Types["UtilityPageTemplateProps"];
}


        
export {Iterator, CSRFToken, createRenderer} from "./forms";
export {getTemplate} from "./template";

